import { Record } from 'immutable';
import { schema } from 'normalizr';

export const SolarSiteOption = new Record({
  id: undefined,
  site: undefined,
  solar_orientation: undefined,
  obstructions_to_solar: undefined,
  tree_trimming_required: undefined,
  solar_panel_manufacturer: undefined,
  solar_panel_model_number: undefined,
  solar_panel_wattage: undefined,
  solar_generator_voltage: undefined,
  solar_panel_tilt: undefined,
  solar_array_serial: undefined,
  panels_per_array: undefined,
  number_of_arrays_installed: undefined,
  total_system_wattage: undefined,
  quantity_of_inverters_installed: undefined,
  inverter_manufacturer: undefined,
  inverter_model_number: undefined,
  inverter_serial_number: undefined,
  inverter_serial_number_2: undefined,
  inverter_serial_number_3: undefined,
  inverter_serial_number_4: undefined,
  inverter_serial_number_5: undefined,
  inverter_serial_number_6: undefined,
  lighting_manufacturer: undefined,
  lighting_model_number: undefined,
  total_number_lights_installed: undefined,
  individual_light_serial_numbers: undefined,
  lighting_design_wattage: undefined,
  lighting_controller_manufacturer: undefined,
  lighting_controller_model_number: undefined,
  lighting_controller_serial_number: undefined,
  number_of_relays_in_controller: undefined,
  meter_number: undefined,
  system_voltage: undefined,
  system_phasing: undefined,
  utility_electrical_permit_number: undefined,
  utility_building_permit_number: undefined,
  array_assembled_by: undefined,
  lighting_installed_by: undefined,
  solar_installed_by: undefined,
  electrical_solar_pv_installed_by: undefined,
  date_electric_permit_granted: undefined,
  date_building_permit_granted: undefined,
  lighting_completion_date: undefined,
  mechanical_solar_completion_date: undefined,
  electrical_completion_date: undefined,
  interconnection_agreement_filed: undefined,
  final_electrical_inspection_date: undefined,
  interconnection_agreement_approved: undefined,
  in_service_date: undefined,
  lighting_photo_number: undefined,
  completed_install_photo_number: undefined,
  array_assembly_labor: undefined,
  lighting_install_cost: undefined,
  solar_install_cost: undefined,
  lighting_controller_install_cost: undefined,
  solar_electrical_cost: undefined,
  solar_mechanical_cost: undefined,
  lighting_cost: undefined,
  lighting_controller_cost: undefined,
  additional_permitting_expense: undefined,
  design_power_consumption: undefined,
  design_power_generation: undefined,
  configuration: undefined,
  nominal_size: undefined,
  number_of_faces: undefined,
  utility_city: undefined,
  utility_county: undefined,
  utility_state: undefined,
  exclude_from_solar_report: undefined,
  solar_active: undefined,
});

export const solarSiteOptionSchema = new schema.Entity('solarSiteOptions');

// for reading in nested models, object with { field: schema }
// solarSiteOptionSchema.define({  });
